import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  width: 250px;
  height: 278px;
  padding: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease-in-out;

  :hover {
    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25);

    img {
      transform: scale(1.1);
      transition: all 0.3s ease-in-out;
    }
  }
`;

export const CardImage = styled.div`
  width: 100%;
  height: 150px;
  overflow: hidden;
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardName = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: #3cc830;
`;

export const CardPrice = styled.p`
  font-weight: bold;
  color: #005900;
  font-size: 1.6rem;
`;
